import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/index.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/privacy.vue')
  },
  {
    path: '/agree',
    name: 'agree',
    component: () => import('@/views/agree.vue')
  },
  {
    path: '/marketing',
    name: 'marketing',
    component: () => import('@/views/marketing.vue')
  },
  {
    path: '/404',
    name: 'not-found',
    component: () => import('@/views/404.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router